export enum ORDER_STATUS {
    COMPLETED = 'completed',
    PROCESSING = 'processing',
    ON_HOLD = 'on-hold',
    CANCELLED = 'cancelled',
    FAILED = 'failed',
}
